import chargebeeGetters from "./getters.js";
import chargebeeMutations from "./mutations.js";
import chargebeeActions from "./actions.js";

// This module works directly with Chargebee - Mutations work directly with Chargebee's API to rectreive data
// Refer to Chargebee API documentation at https://apidocs.chargebee.com/docs/api/
export default {
  namespaced: true,
  state() {
    return {
      status: null,
      accountLocked: false,
      billingLoaded: false,
      invoicesLoaded: false,
      unbilledCharges: null,
      paymentMethod: null,
      taxability: null,
      nextBillingAt: null,
      promotionalCredits: null,
      dueInvoiceCount: null,
      billingPeriodUnit: null,
      currencySymbol: null,
      currencyCode: null,
      unpaidCharges: null,
      billingAddress: null,
      storedCard: {},
      invoiceData: [],
      products: [],
    };
  },
  getters: chargebeeGetters,
  mutations: chargebeeMutations,
  actions: chargebeeActions,
};
